import { render, staticRenderFns } from "./produto-item-card.html?vue&type=template&id=66b7cffa&scoped=true&"
import script from "./produto-item-card.vue?vue&type=script&lang=js&"
export * from "./produto-item-card.vue?vue&type=script&lang=js&"
import style0 from "./produto-item-card.less?vue&type=style&index=0&id=66b7cffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7cffa",
  null
  
)

export default component.exports